const Profile = () => {
  return (
    <div>
      <h2>My Profile</h2>
      <ul>
        <li>My Name</li>
        <l1>DOB</l1>
      </ul>
    </div>
  );
};

export default Profile;
